import React, { useState, useEffect, useContext } from 'react'
import { WdContext } from "../../context/WdProvider";
import WplPopup from "../wpl-popup-window/WplPopup";
import WplTable from "../wpl-table/WplTable";
import './defect-list-popup.css'

export default function DefectListPopup({ defects, isOpen = true, onClose, title }) {
    const { selectedDefect, setSelectedDefect } = useContext(WdContext);
    

    function doClose() {
        setSelectedDefect('');
        onClose()
    }

    useEffect(() => {
        if (isOpen && defects.length === 1 && !selectedDefect) {
            setSelectedDefect(defects[0])
        }
    }, [isOpen, defects, selectedDefect]);

    if (!isOpen) return null;

    return (
        <WplPopup className='distance-list-popup' showPopup={isOpen}
            closePopup={doClose}>
            {title}
            <WplTable defects={defects} selectedDefect={selectedDefect}  inlineSelectable={true} />
        </WplPopup>)
}
